import { Router } from '@angular/router';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const EVENT_FORM_KEYS_OMIT_FROM_TEMPLATE = new Set([
  'new_edit_copy',
  'event_id',
  'event_guid',
  'open_catering_wishes',
  'linked_event_group_id',
  'parent_event_id',
  'is_series_anchor',
  'series_schedule_editable',
  'primary_session_guid',
  'schedule_mode',
  'schedule_inferred_mode',
  'schedule_crosses_days',
  'series_share_participants',
  'series_planner_active',
  'series_planning_mode',
  'series_default_start_time',
  'series_default_end_time',
  'series_dates',
  'series_exceptions',
  'additional_dates',
  'multi_day_skip_dates',
  'event_name',
]);

export function isOmittedFromTemplatePayload(key: string): boolean {
  return EVENT_FORM_KEYS_OMIT_FROM_TEMPLATE.has(key);
}

/** First UUID segment in the current app URL (same convention as event_form_data). */
export function getEventUuidFromAppUrl(router: Router): string | null {
  const path =
    typeof window !== 'undefined'
      ? window.location.pathname
      : router.url.split('?')[0];
  const segments = path.replace(/^\//, '').split('/');
  const found = segments.find((segment) => UUID_REGEX.test(segment));
  return found ?? null;
}

export function eventFormLabelFromSeed(
  formData: Record<string, unknown>
): string {
  const short = String(formData['short_description'] || '').trim();
  if (short) return short;
  const name = String(formData['event_name'] || '').trim();
  if (name) return name;
  const long = String(formData['description'] || '').trim();
  if (long) {
    return long.length > 80 ? `${long.slice(0, 77)}…` : long;
  }
  return 'event';
}

/** Strip edit/series fields and normalize schedule for single-day template data. */
export function stripEventFormForTemplateSeed(
  formData: Record<string, unknown>
): Record<string, unknown> {
  const seed: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(formData)) {
    if (!EVENT_FORM_KEYS_OMIT_FROM_TEMPLATE.has(key)) {
      seed[key] = value;
    }
  }
  seed['event_duration_type'] = 'single_day';
  if (!seed['end_time'] && seed['end_date']) {
    const end = String(seed['end_date']);
    const timePart = end.includes('T') ? end.split('T')[1] : end.split(' ')[1];
    if (timePart) {
      seed['end_time'] = timePart.slice(0, 5);
    }
  }
  delete seed['end_date'];
  delete seed['sub_events'];
  return seed;
}
